export function canAccessTrovaOspiti(user) {
  return Boolean(user?.trova_ospiti_enabled);
}

export function canAccessTrovaPersonale(user) {
  return Boolean(user?.trova_personale_enabled);
}
